import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicio",
    },
    {
        path: "/servicios/hotel",
        label: "Hotel",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarServicioHotel(){
    return (
        <Page title="Edición de servicio de hotel" description="Modificación de tarifas de hospedaje." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarServicioHotel;